import React from 'react';

/**
 * Dropdown selector for WhatsApp reminder hours
 */
export function ReminderHoursSelector({ value, onChange, disabled = false }) {
  const options = [
    { value: 6, label: '6 horas antes' },
    { value: 8, label: '8 horas antes' },
    { value: 12, label: '12 horas antes' },
    { value: 24, label: '24 horas antes' }
  ];

  return (
    <div className="py-4 border-b border-gray-200">
      <label 
        htmlFor="reminder-hours" 
        className="block text-sm font-medium text-gray-900 mb-2"
      >
        Lembrete de Confirmação por WhatsApp
      </label>
      <p className="text-sm text-gray-500 mb-3">
        Escolha a antecedência com que o paciente receberá mensagem para confirmar atendimento
      </p>
      <select
        id="reminder-hours"
        value={value}
        onChange={(e) => onChange(Number(e?.target?.value))}
        disabled={disabled}
        className="block w-full max-w-xs rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {options?.map((option) => (
          <option key={option?.value} value={option?.value}>
            {option?.label}
          </option>
        ))}
      </select>
    </div>
  );
}